import { CurrencyConvertion } from "../utils/Validate";
const calculateQuoteStatistics = (data,currencyList) => {
  
    let totalQuotes = 0;
    let activeQuotes = 0;
    let quoted = 0;
    let active = 0;
    let lost = 0;
    let order = 0;
    if (Array.isArray(data)) {
    data?.map((item,index)=>{
      totalQuotes += 1
      let quoteValue = (CurrencyConvertion(item?.grandTotal,item?.conversionRate,currencyList?.find(item => item?.id === item?.currencyId))*1)
      quoted += quoteValue
      if (
        item.quoteStatusId === 1 ||
        item.quoteStatusId === 2 ||
        item.quoteStatusId === 3 ||
        item.quoteStatusId === 4
      ) {
        activeQuotes += 1;
        active += quoteValue;
      }

      if (item.quoteStatusId === 6) {
        lost += quoteValue;
      }

      if (item.quoteStatusId === 5) {
        order += quoteValue;
      }

    })
  }
    
    return {
      totalQuotes,
      activeQuotes,
      quoted,
      active,
      lost,
      order
    };
  };
  
  export default calculateQuoteStatistics;
  